"use strict";
// @ts-ignore
try {
    self['workbox:routing:6.5.0'] && _();
}
catch (e) { }
